/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/*
 * Selector de cantitate independent pentru tema CSF/Warehouse veche.
 * Foloseste actiuni proprii pentru a nu depinde de initializarea scriptului
 * produsului, care poate esua la produse cu un numar mare de variante.
 */
(function () {
  'use strict';

  function getQuantityInput(button) {
    var selector = button.closest('.quantity-selector--product');
    return selector ? selector.querySelector('input[name="quantity"]') : null;
  }

  function normalizeQuantity(input) {
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var value = parseInt(input.value, 10);

    if (!Number.isFinite(value) || value < min) {
      value = min;
    }

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '[data-action="csf-decrease-picker-quantity"], [data-action="csf-increase-picker-quantity"]'
    );

    if (!button) {
      return;
    }

    var input = getQuantityInput(button);
    if (!input) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var value = parseInt(input.value, 10) || 1;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;

    if (button.getAttribute('data-action') === 'csf-increase-picker-quantity') {
      value += step;
    } else {
      value = Math.max(min, value - step);
    }

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('.quantity-selector--product input[name="quantity"]')) {
      normalizeQuantity(event.target);
    }
  });

  document.addEventListener('blur', function (event) {
    if (event.target.matches('.quantity-selector--product input[name="quantity"]')) {
      normalizeQuantity(event.target);
    }
  }, true);
})();
